import * as React from 'react';
import { ISummaryPanelProperties } from '../interfaces';
import SummaryTableSchema from './SummaryTableSchema';
import SummaryPanel from 'components/common/SummaryPanel';

const PurchaseOrderEnquiryummaryPanel = ({ isLoading, orderSummary }: ISummaryPanelProperties) => {

  return (
    <React.Fragment>
      <SummaryPanel
        loading={isLoading}
        data={orderSummary ?? {}}
        schema={SummaryTableSchema}
      />
    </React.Fragment>
  );
};

export default PurchaseOrderEnquiryummaryPanel;
